import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import AddChildInteractionButton from "../../../AddChildInteractionButton";
import { useStoreDispatch, useStoreSelector } from "../../../../../store/Hooks";
import Divider from "@mui/material/Divider";

import Interaction from "../../../../../models/interactions/Interaction";
import InteractionNode from "../../../../../models/interactions/InteractionNode";
import ConditionBar from "../../../../conditions/ConditionBar";
import CommitButton from "../../../../commit/CommitButton";
import InteractionEditButton from "../../../ui/InteractionEditButton";
import InteractionTypeIndicator from "../../../ui/interactionpropdisplay/typeindicators/InteractionTypeIndicator";
import InteractionDeleteButton from "../../../ui/InteractionDeleteButton";
// NOTE: THIS IS ONLY BEING USED FOR PATHWAYS IN NODES RIGHT NOW
interface AccountProps {
  childInteractions: Array<any>;
  // childIntervalSets: Array<any>;
  interaction: Interaction;
  rootInteractionID: number;
  node: InteractionNode | null;
  handleDeleteInteraction: any;
}

const Account = (props: AccountProps) => {
  const previewMode = useStoreSelector((state) => state.nav.previewMode);

  let setID = props.rootInteractionID;
  let parentID = props.rootInteractionID;
  if (props.node) {
    if (props.node.set_interaction_id) {
      setID = props.node.set_interaction_id;
    }
    if (props.node.id) {
      parentID = props.node.child_interaction_id;
    }
  }
  // if this pathway is the selected rootInteractionID,
  // its immediate children should be shown differently than
  // the descendants of those immediate children
  return (
    <div style={{ margin: "10px", padding: "10px 60px" }}>
      {props.node && props.node.condition_id !== null && (
        <div>
          <ConditionBar
            sx={{
              // position: "absolute",
              // left: 0,
              // top: 0,
              height: "500px",
              width: "100%",
            }}
            table={InteractionNode}
            tableID={props.node.id}
          />
        </div>
      )}
      {/* {!previewMode &&  (
                <AddChildInteractionButton
                    setID={setID}
                    parentID={parentID}
                    type={props.interaction.properties.type}
                    main={false}
                    numChildren={props.childInteractions.length}
                    intervalSetID={null}
                />
            )} */}

      <span style={{ float: "right" }}>
        <InteractionTypeIndicator
          type={props.interaction.properties.type}
          variant="outlined"
        />
      </span>
      <h2>
        {props.interaction.title}
        <CommitButton setID={setID} parentID={parentID} />
        {!previewMode && (
          <InteractionEditButton interaction={props.interaction} />
        )}
        {!previewMode && (
          <InteractionDeleteButton
            interaction={props.interaction}
            handler={props.handleDeleteInteraction}
          />
        )}
        &nbsp; &nbsp;
      </h2>
      <Divider />
      {props.childInteractions}
    </div>
  );
};
export default Account;
